import axios from "axios";
import { handleSessionExpired } from "./sessionExpiry";
import { REQUEST_TIMEOUT_MS, retryOnce, normalizeApiError, isSessionError } from "./apiErrorHandling";

// Add token to requests after login
const backgroundAxiosInstance = axios.create({
    baseURL:process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
    timeout: REQUEST_TIMEOUT_MS,
});
backgroundAxiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
backgroundAxiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {

        console.error("API Error:", error);
        const retried = await retryOnce(backgroundAxiosInstance, error);
        if (retried) return retried;
        normalizeApiError(error);
        if (isSessionError(error)) {
            handleSessionExpired();
        }
        return Promise.reject(error);
    }
);
export default backgroundAxiosInstance